const messages = {
  title: "Árlisták és termékbrosúrák",
  description:
    "Töltse le a legújabb brosúrákat és szórólapokat Bridgestone és Firestone gumiabroncsairól személygépkocsikhoz, SUV-khoz és kishaszongépjárművekhez.",
  brochureCategories: {
    products: "Termékek",
    brand_and_solutions: "Márka és megoldások",
    season_and_promotions: "Szezon és promóciók",
    format: "Formátum",
    cars_and_vans: "Személyautó, SUV, haszonjármű",
    summer: "Nyár",
    winter: "Tél",
    promotions: "Promóciók",
    all_season: "Négyévszakos",
    truck_and_buses: "Teherautó és busz",
    motorcycle: "Motorkerékpár",
    agriculture: "Mezőgazdaság",
    construction_machinery: "Építőipari gépek",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Anyagok",
    brochures: "Termékbrosúrák",
    price_list: "Árlisták",
    materials: "Anyagok",
    video_in_store: "Videó felirattal",
    video_online: "Videó felirat nélkül",
    banner_website: "Banner",
    banner_social_media: "Közösségi média",
    logos: "Logók",
  },
  searchMedia: "Adjon meg kulcsszót",
  searchResults: "Keresési eredmények",
};

export default {
  messages,
};
